// Suppress noisy console warnings in development
const originalWarn = console.warn;
console.warn = (...args: unknown[]) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (
    msg.includes('React Router Future Flag Warning') ||
    msg.includes('Relative route resolution within Splat routes')
  ) {
    return;
  }
  originalWarn.apply(console, args);
};
